// wrapper of https://github.com/typestack/class-transformer
import {
  Type,
  Expose,
  Exclude,
  plainToInstance as _plainToInstance,
  instanceToPlain,
  ClassConstructor,
} from 'class-transformer';

/**
 * @description
 * Use this to transform a plain object to an instance of a specific class
 * 
 * `excludeExtraneousValues`: properties from the plain object that are not specified are ignored, because
 *   domain entities rules over data in our client
 *     `@Expose() prop: type` is mandatory
 *  
 * `enableImplicitConversion`: automatic conversion between built-in types based on type information provided by Typescript,
 *   because our domain entities rules over data type in our client
 */
const plainToInstance = <T, V>(Class: ClassConstructor<T>, plainData: V) =>
  _plainToInstance(Class, plainData, {
    excludeExtraneousValues: true,
    enableImplicitConversion: true,
  });

export {
  plainToInstance,
  instanceToPlain,
  Type, // https://github.com/typestack/class-transformer#working-with-nested-objects
  Expose, // https://github.com/typestack/class-transformer#exposing-getters-and-method-return-values
  Exclude, // https://github.com/typestack/class-transformer#skipping-depend-of-operation
};
